import { z } from "zod";

/** Mirrors ReferralStatus on the server (Dataverse statuscode values). */
export const REFERRAL_STATUS = {
  SignedUp: 1,
  Inactive: 2,
  TrialStarted: 100000001,
  RewardEarned: 100000002,
  CustomerChurned: 100000003,
} as const;

export const ReferralStatusSchema = z.nativeEnum(REFERRAL_STATUS);

export const ReferralItemSchema = z.object({
  Id: z.string(),
  Name: z.string().optional(),
  RefereeAccountName: z.string().optional(),
  RefereeContactName: z.string().optional(),
  ReferrerAccountName: z.string().optional(),
  Status: ReferralStatusSchema,
  SignedUpon: z.string().optional(),
  TrialStartedOn: z.string().optional(),
  ConvertedOn: z.string().optional(),
  ChurnedOn: z.string().optional(),
});

export type ReferralStatusType = z.infer<typeof ReferralStatusSchema>;
export type ReferralItemType = z.infer<typeof ReferralItemSchema>;
